const CONFIG_OBJECT = Object.freeze({
    SWAGGER_REST_URL : '/api/utilities/v1/document/swaggerapi',
    FUNCTIONAL_DOCUMENT_REST_URL : '/api/utilities/v1/document/DownloadFile',
    OC_REST_URL : '/api/utilities/v2/ovulationcalculator/ovulationresult',    
    DDC_REST_URL_V2 : '/api/utilities/v2/duedate/duedateresult',
    DDC_REST_URL : '/api/utilities/v3/duedate/duedateresult',
    BNF_REST_URL : '/api/utilities/v1/babynameservice/babynameslist',
    GP_REST_URL: '/api/utilities/v1/genderpredictorservice/babygender',
    ECP_REST_URL: '/api/utilities/v1/eyecolorpredictor/eyecolorprediction',
    HP_REST_URL: '/api/utilities/v1/heightpredictorservice/heightprediction',
    DC_TRIP_REST_URL_V2 : '/api/utilities/v2/diapercalculatorservice/tripeventdiaper',
    DC_TRIP_REST_URL : '/api/utilities/v1/diapercalculatorservice/tripeventdiaper',
    DC_TEA_REST_URL : '/api/utilities/v1/diapercalculatorservice/teaeventdiaper',
    RF_REST_URL: '/api/utilities/v1/recipefinder/recipe',
    RFR_REST_URL: '/api/utilities/v1/recipefinder/recipekeyword',
    RFEMAIL_REST_URL:'api/utilities/v1/recipefinder/email',
    PERIOD_CALCULATOR_REST_URL: 'api/utilities/v1/PeriodCalculator/PeriodDays',
    PERIOD_CALCULATOR_ALLDAYS_REST_URL: 'api/utilities/v1/PeriodCalculator/PeriodAndPregnantDays',
    GETTING_PREGNANT_REST_URL: 'api/utilities/v1/PeriodCalculator/PregnantDays',
    GETTING_FERTILE_DAYS_REST_URL: 'api/utilities/v1/PeriodCalculator/FertileDays',
    GETTING_OVULATION_DAYS_REST_URL: 'api/utilities/v1/PeriodCalculator/OvulationDays',
    SET_REMINDERS_REST_URL: 'api/utilities/v1/PeriodCalculator/DownloadICalFile',
    FUTURE_DATES_REST_URL: 'api/utilities/v1/PeriodCalculator/FutureDates',
    ATC_REST_URL:"/api/utilities/v1/calendarservice/downloadicalfile",
    ACTIVITYFINDER_REST_URL: "/api/utilities/v1/activityfinder/activity",
    BABY_NAME_FINDER_REST_URL: '/api/utilities/v2/BabyNameFinder/BabyNames',
    BABY_MIDDLE_NAME_FINDER_REST_URL: '/api/utilities/v2/BabyNameFinder/BabyMiddleNames',
    BABY_AUTO_NAME_FINDER_REST_URL: '/api/utilities/v2/BabyNameFinder/autocomplete',
    ALL_BABY__NAMES_REST_URL: '/api/utilities/v1/BabyNameFinder/AllBabyNames',
    POPULAR_NAMES_BY_YEAR_REST_URL: '/api/utilities/v1/BabyNameFinder/PopularNamesByYear',
    DIAPER_SIZE_FINDER_REST_URL: '/api/utilities/v1/DiaperSizeCalculator/DiaperSizeFinder',
    DIAPERS_PER_DAY_REST_URL: '/api/utilities/v1/DiaperSizeCalculator/DiapersPerDay',
    DIAPERS_PER_TRIP_REST_URL: '/api/utilities/v1/DiaperSizeCalculator/DiapersPerTrip',
    WEIGHTGAIN_CALCULATOR_REST_URL: '/api/utilities/v1/WeightGainCalculatorService/WeightGain',
    PRODUCT_INGREDIENT_REST_URL: '/api/utilities/v1/GetProducts',
});

export default CONFIG_OBJECT;